/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import srcVirtualAgentPerformanceStatisticsQuery from './__generated__/VirtualAgentPerformanceQuery$parameters';
import type { VirtualAgentPerformanceQuery } from './__generated__/VirtualAgentPerformanceQuery.graphql.ts';

const DEFAULT_TIME_RANGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

const formatFetchDate = (date: Date) => date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

type PerformanceEntryPointComponent = EntryPointComponent<
	{
		page: VirtualAgentPerformanceQuery;
	},
	{},
	{},
	{} | null
>;

export const performanceEntryPoint: EntryPoint<
	PerformanceEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<PerformanceEntryPointComponent>(
		/* webpackChunkName: "async-virtual-agent-performance" */ './VirtualAgentPerformance.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: srcVirtualAgentPerformanceStatisticsQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey?.toUpperCase() ?? '',
					startDate: formatFetchDate(new Date(Date.now() - DEFAULT_TIME_RANGE_MS)),
					endDate: formatFetchDate(new Date()),
				},
			},
		},
	}),
});
